<script setup lang="ts">
import { useField } from 'vee-validate';
import { toRef } from 'vue';
import DurationField from './DurationField.vue';
import type { VeeDurationFieldProps } from '../types';
import { useVeeFormProps } from '../utils';

const props = defineProps<VeeDurationFieldProps>();

const veeProps = useVeeFormProps(props);

const { errorMessage, value, handleChange, handleBlur, meta } = useField<number | undefined>(
  toRef(() => props.name),
  undefined,
  {
    validateOnValueUpdate: false,
  },
);

function onUpdate(input: number | undefined) {
  handleChange(input, meta.touched);
}

function onBlur(event: Event) {
  handleBlur(event, true);
}
</script>

<template>
  <DurationField
    v-bind="veeProps"
    :modelValue="value"
    :errorMessage="errorMessage"
    @update:modelValue="onUpdate"
    @blur="onBlur"
  />
</template>
